import { DEFAULTS } from './defaults';

export const HEADERS = {
  ALL: [
    {
      text: 'Customer Verified',
      align: 'center',
      value: 'customer_verified',
      width: 5,
      'max-width': 20
    },
    {
      text: 'Status',
      align: 'center',
      value: 'status',
      width: 20,
      'max-width': 20
    },
    {
      text: 'Original category name',
      align: 'center',
      value: 'orig_cat1',
      width: 200
    },
    {
      text: 'Original code',
      align: 'center',
      value: 'orig_code',
      width: 100
    },
    {
      text: 'Original name',
      align: 'center',
      value: 'orig_name',
      width: 100
    },
    {
      text: 'Rhapsody name',
      align: 'center',
      value: 'rhapsody_name',
      width: 100
    },
    {
      text: 'Entry variation name',
      align: 'center',
      value: 'entry_variation_name',
      width: 100
    },
    {
      text: 'Category',
      align: 'center',
      value: 'category',
      width: 100
    },
    {
      text: 'Rhapsody code',
      align: 'center',
      value: 'rhapsody_code',
      width: 100
    },
    {
      width: 100,
      text: 'Price',
      align: 'center',
      value: 'priceInfo.price',
      sortable: false
    },
    {
      text: 'Last comment',
      align: 'center',
      value: 'lastComment',
      width: 200
    },
    {
      text: 'Details',
      align: 'center',
      value: 'actions',
      width: 50
    }
  ],
  PROCEDURES: [
    {
      text: 'Customer Verified',
      align: 'center',
      value: 'customer_verified',
      width: 5,
      'max-width': 20
    },
    {
      text: 'Status',
      align: 'center',
      value: 'status'
    },
    {
      text: 'Original category name',
      align: 'center',
      value: 'orig_cat1'
    },
    {
      text: 'Original code',
      align: 'center',
      value: 'orig_code'
    },
    {
      text: 'Original name',
      align: 'center',
      value: 'orig_name'
    },
    {
      text: 'Rhapsody name',
      align: 'center',
      value: 'rhapsody_name'
    },
    {
      text: 'Entry variation name',
      align: 'center',
      value: 'entry_variation_name'
    },
    {
      text: 'Rhapsody code',
      align: 'center',
      value: 'rhapsody_code'
    },
    {
      width: 100,
      text: 'Price',
      align: 'center',
      value: 'priceInfo.price',
      sortable: false
    },
    {
      text: 'Last comment',
      align: 'center',
      value: 'lastComment',
      width: 200
    },
    {
      text: 'Details',
      align: 'center',
      value: 'actions'
    }
  ],
  LABS: [
    {
      text: 'Customer Verified',
      align: 'center',
      value: 'customer_verified',
      width: 5,
      'max-width': 20
    },
    {
      text: 'Status',
      align: 'center',
      value: 'status'
    },
    {
      text: 'Original category name',
      align: 'center',
      value: 'orig_cat1'
    },
    {
      text: 'Original code',
      align: 'center',
      value: 'orig_code'
    },
    {
      text: 'Original name',
      align: 'center',
      value: 'orig_name'
    },
    {
      text: 'Rhapsody name',
      align: 'center',
      value: 'rhapsody_name'
    },
    {
      text: 'Entry variation name',
      align: 'center',
      value: 'entry_variation_name'
    },
    {
      text: 'Rhapsody code',
      align: 'center',
      value: 'rhapsody_code'
    },
    {
      text: 'Vendor ',
      align: 'center',
      value: 'vendor'
    },
    {
      text: 'Vendor code',
      align: 'center',
      value: 'vendor_code'
    },
    {
      width: 100,
      text: 'Price',
      align: 'center',
      value: 'priceInfo.price',
      sortable: false
    },
    {
      text: 'Last comment',
      align: 'center',
      value: 'lastComment',
      width: 200
    },
    {
      text: 'Details',
      align: 'center',
      value: 'actions'
    }
  ],
  DRUGS: [
    {
      text: 'Customer Verified',
      align: 'center',
      value: 'customer_verified',
      width: 5,
      'max-width': 20
    },
    {
      text: 'Status',
      align: 'center',
      value: 'status'
    },
    {
      text: 'Original category name',
      align: 'center',
      value: 'orig_cat1'
    },
    {
      text: 'Original code',
      align: 'center',
      value: 'orig_code'
    },
    {
      text: 'Original name',
      align: 'center',
      value: 'orig_name'
    },
    {
      text: 'Rhapsody name',
      align: 'center',
      value: 'rhapsody_name'
    },
    {
      text: 'Entry variation name',
      align: 'center',
      value: 'entry_variation_name'
    },
    {
      text: 'Rhapsody code',
      align: 'center',
      value: 'rhapsody_code'
    },
    {
      text: 'Variation ',
      align: 'center',
      value: 'variation'
    },
    {
      width: 100,
      text: 'Price',
      align: 'center',
      value: 'priceInfo.price',
      sortable: false
    },
    {
      text: 'Last comment',
      align: 'center',
      value: 'lastComment',
      width: 200
    },
    {
      text: 'Details',
      align: 'center',
      value: 'actions'
    }
  ],
  VACCINES: [
    {
      text: 'Customer Verified',
      align: 'center',
      value: 'customer_verified',
      width: 5,
      'max-width': 20
    },
    {
      text: 'Status',
      align: 'center',
      value: 'status'
    },
    {
      text: 'Original category name',
      align: 'center',
      value: 'orig_cat1'
    },
    {
      text: 'Original code',
      align: 'center',
      value: 'orig_code'
    },
    {
      text: 'Original name',
      align: 'center',
      value: 'orig_name'
    },
    {
      text: 'Rhapsody name',
      align: 'center',
      value: 'rhapsody_name'
    },
    {
      text: 'Entry variation name',
      align: 'center',
      value: 'entry_variation_name'
    },
    {
      text: 'Rhapsody code',
      align: 'center',
      value: 'rhapsody_code'
    },
    {
      text: 'Variation ',
      align: 'center',
      value: 'variation'
    },
    {
      width: 100,
      text: 'Price',
      align: 'center',
      value: 'priceInfo.price',
      sortable: false
    },
    {
      text: 'Last comment',
      align: 'center',
      value: 'lastComment',
      width: 200
    },
    {
      text: 'Details',
      align: 'center',
      value: 'actions'
    }
  ],
  FOOD: [
    {
      text: 'Customer Verified',
      align: 'center',
      value: 'customer_verified',
      width: 5,
      'max-width': 20
    },
    {
      text: 'Status',
      align: 'center',
      value: 'status'
    },
    {
      text: 'Original category name',
      align: 'center',
      value: 'orig_cat1'
    },
    {
      text: 'Original code',
      align: 'center',
      value: 'orig_code'
    },
    {
      text: 'Original name',
      align: 'center',
      value: 'orig_name'
    },
    {
      text: 'Rhapsody name',
      align: 'center',
      value: 'rhapsody_name'
    },
    {
      text: 'Entry variation name',
      align: 'center',
      value: 'entry_variation_name'
    },
    {
      text: 'Subcategory ',
      align: 'center',
      value: 'subcategory'
    },
    {
      width: 100,
      text: 'Price',
      align: 'center',
      value: 'priceInfo.price',
      sortable: false
    },
    {
      text: 'Last comment',
      align: 'center',
      value: 'lastComment',
      width: 200
    },
    {
      text: 'Details',
      align: 'center',
      value: 'actions'
    }
  ],
  SUPPLIES: [
    {
      text: 'Customer Verified',
      align: 'center',
      value: 'customer_verified',
      width: 5,
      'max-width': 20
    },
    {
      text: 'Status',
      align: 'center',
      value: 'status'
    },
    {
      text: 'Original category name',
      align: 'center',
      value: 'orig_cat1'
    },
    {
      text: 'Original code',
      align: 'center',
      value: 'orig_code'
    },
    {
      text: 'Original name',
      align: 'center',
      value: 'orig_name'
    },
    {
      text: 'Rhapsody name',
      align: 'center',
      value: 'rhapsody_name'
    },
    {
      text: 'Entry variation name',
      align: 'center',
      value: 'entry_variation_name'
    },
    {
      text: 'Subcategory ',
      align: 'center',
      value: 'subcategory'
    },
    {
      width: 100,
      text: 'Price',
      align: 'center',
      value: 'priceInfo.price',
      sortable: false
    },
    {
      text: 'Last comment',
      align: 'center',
      value: 'lastComment',
      width: 200
    },
    {
      text: 'Details',
      align: 'center',
      value: 'actions'
    }
  ],
  IGNORED: [
    {
      text: 'Customer Verified',
      align: 'center',
      value: 'customer_verified',
      width: 5,
      'max-width': 20
    },
    {
      text: 'Status',
      align: 'center',
      value: 'status'
    },
    {
      text: 'Original category name',
      align: 'center',
      value: 'orig_cat1'
    },
    {
      text: 'Original code',
      align: 'center',
      value: 'orig_code'
    },
    {
      text: 'Original name',
      align: 'center',
      value: 'orig_name'
    },
    {
      text: 'Rhapsody name',
      align: 'center',
      value: 'rhapsody_name'
    },
    {
      text: 'Entry variation name',
      align: 'center',
      value: 'entry_variation_name'
    },
    {
      width: 100,
      text: 'Price',
      align: 'center',
      value: 'priceInfo.price',
      sortable: false
    },
    {
      text: 'Last comment',
      align: 'center',
      value: 'lastComment',
      width: 200
    },
    {
      text: 'Details',
      align: 'center',
      value: 'actions'
    }
  ],
  UNMATCHED: [
    {
      text: 'Customer Verified',
      align: 'center',
      value: 'customer_verified',
      width: 5,
      'max-width': 20
    },
    {
      text: 'Status',
      align: 'center',
      value: 'status'
    },
    {
      text: 'Original category name',
      align: 'center',
      value: 'orig_cat1'
    },
    {
      text: 'Original code',
      align: 'center',
      value: 'orig_code'
    },
    {
      text: 'Original name',
      align: 'center',
      value: 'orig_name'
    },
    {
      width: 100,
      text: 'Price',
      align: 'center',
      value: 'priceInfo.price',
      sortable: false
    },
    {
      text: 'Last comment',
      align: 'center',
      value: 'lastComment',
      width: 200
    },
    {
      text: 'Details',
      align: 'center',
      value: 'actions'
    }
  ],
  MULTI_MATCH: [
    {
      text: 'Customer Verified',
      align: 'center',
      value: 'customer_verified',
      width: 5,
      'max-width': 20
    },
    {
      text: 'Multi match selection',
      align: 'center',
      value: 'multimatch_selection',
      width: '10',
      sortable: false
    },
    {
      text: 'Status',
      align: 'center',
      value: 'status'
    },
    {
      text: 'Original category name',
      align: 'center',
      value: 'orig_cat1'
    },
    {
      text: 'Rhapsody name',
      align: 'center',
      value: 'rhapsody_name'
    },
    {
      text: 'Category name',
      align: 'center',
      value: 'category'
    },
    {
      width: 100,
      text: 'Price',
      align: 'center',
      value: 'priceInfo.price',
      sortable: false
    },
    {
      text: 'Last comment',
      align: 'center',
      value: 'lastComment',
      width: 200
    },
    {
      text: 'Details',
      align: 'center',
      value: 'actions'
    }
  ],
  ASK_CUSTOMER: [
    {
      text: 'Customer Verified',
      align: 'center',
      value: 'customer_verified',
      width: 5,
      'max-width': 20
    },
    {
      text: 'Status',
      align: 'center',
      value: 'status'
    },
    {
      text: 'Last comment',
      align: 'center',
      value: 'lastComment',
      width: 200
    },
    {
      text: 'Original category name',
      align: 'center',
      value: 'orig_cat1'
    },
    {
      text: 'Original code',
      align: 'center',
      value: 'orig_code'
    },
    {
      text: 'Original name',
      align: 'center',
      value: 'orig_name'
    },
    {
      text: 'Rhapsody name',
      align: 'center',
      value: 'rhapsody_name'
    },
    {
      text: 'Category name',
      align: 'center',
      value: 'category'
    },
    {
      width: 100,
      text: 'Price',
      align: 'center',
      value: 'priceInfo.price',
      sortable: false
    },
    {
      text: 'Details',
      align: 'center',
      value: 'actions'
    }
  ],
  ADDITIONAL_REVIEW: [
    {
      text: 'Customer Verified',
      align: 'center',
      value: 'customer_verified',
      width: 5,
      'max-width': 20
    },
    {
      text: 'Status',
      align: 'center',
      value: 'status'
    },
    {
      text: 'Original category name',
      align: 'center',
      value: 'orig_cat1'
    },
    {
      text: 'Original code',
      align: 'center',
      value: 'orig_code'
    },
    {
      text: 'Original name',
      align: 'center',
      value: 'orig_name'
    },
    {
      text: 'Rhapsody name',
      align: 'center',
      value: 'rhapsody_name'
    },
    {
      text: 'Category name',
      align: 'center',
      value: 'category'
    },
    {
      width: 100,
      text: 'Price',
      align: 'center',
      value: 'priceInfo.price',
      sortable: false
    },
    {
      text: 'Details',
      align: 'center',
      value: 'actions'
    },
    {
      text: 'Last comment',
      align: 'center',
      value: 'lastComment',
      width: 200
    }
  ],
  ADDITIONAL_ANALYSIS: [
    {
      text: 'Customer Verified',
      align: 'center',
      value: 'customer_verified',
      width: 5,
      'max-width': 20
    },
    {
      text: 'Status',
      align: 'center',
      value: 'status'
    },
    {
      text: 'Original category name',
      align: 'center',
      value: 'orig_cat1'
    },
    {
      text: 'Original code',
      align: 'center',
      value: 'orig_code'
    },
    {
      text: 'Original name',
      align: 'center',
      value: 'orig_name'
    },
    {
      text: 'Rhapsody name',
      align: 'center',
      value: 'rhapsody_name'
    },
    {
      text: 'Category name',
      align: 'center',
      value: 'category'
    },
    {
      width: 100,
      text: 'Price',
      align: 'center',
      value: 'priceInfo.price',
      sortable: false
    },
    {
      text: 'Last comment',
      align: 'center',
      value: 'lastComment',
      width: 200
    },
    {
      text: 'Details',
      align: 'center',
      value: 'actions'
    }
  ],
  CONFLICTS: [
    {
      text: 'Customer Verified',
      align: 'center',
      value: 'customer_verified',
      width: 5,
      'max-width': 20
    },
    {
      text: 'Status',
      align: 'center',
      value: 'status'
    },
    {
      text: 'Original category name',
      align: 'center',
      value: 'orig_cat1'
    },
    {
      text: 'Original code',
      align: 'center',
      value: 'orig_code'
    },
    {
      text: 'Original name',
      align: 'center',
      value: 'orig_name'
    },
    {
      text: 'Rhapsody name',
      align: 'center',
      value: 'rhapsody_name'
    },
    {
      text: 'Category name',
      align: 'center',
      value: 'category'
    },
    {
      width: 100,
      text: 'Price',
      align: 'center',
      value: 'priceInfo.price',
      sortable: false
    },
    {
      text: 'Last comment',
      align: 'center',
      value: 'lastComment',
      width: 200
    },
    {
      text: 'Details',
      align: 'center',
      value: 'actions'
    }
  ],
  NEEDS_CHANGE: [
    {
      text: 'Customer Verified',
      align: 'center',
      value: 'customer_verified',
      width: 5,
      'max-width': 20
    },
    {
      text: 'Status',
      align: 'center',
      value: 'status'
    },
    {
      text: 'Original category name',
      align: 'center',
      value: 'orig_cat1'
    },
    {
      text: 'Original code',
      align: 'center',
      value: 'orig_code'
    },
    {
      text: 'Original name',
      align: 'center',
      value: 'orig_name'
    },
    {
      text: 'Rhapsody name',
      align: 'center',
      value: 'rhapsody_name'
    },
    {
      text: 'Category name',
      align: 'center',
      value: 'category'
    },
    {
      width: 100,
      text: 'Price',
      align: 'center',
      value: 'priceInfo.price',
      sortable: false
    },
    {
      text: 'Last comment',
      align: 'center',
      value: 'lastComment',
      width: 200
    },
    {
      text: 'Details',
      align: 'center',
      value: 'actions'
    }
  ],
  NEEDS_RE_REVIEW: [
    {
      text: 'Customer Verified',
      align: 'center',
      value: 'customer_verified',
      width: 5,
      'max-width': 20
    },
    {
      text: 'Status',
      align: 'center',
      value: 'status'
    },
    {
      text: 'Original category name',
      align: 'center',
      value: 'orig_cat1'
    },
    {
      text: 'Original code',
      align: 'center',
      value: 'orig_code'
    },
    {
      text: 'Original name',
      align: 'center',
      value: 'orig_name'
    },
    {
      text: 'Rhapsody name',
      align: 'center',
      value: 'rhapsody_name'
    },
    {
      text: 'Category name',
      align: 'center',
      value: 'category'
    },
    {
      width: 100,
      text: 'Price',
      align: 'center',
      value: 'priceInfo.price',
      sortable: false
    },
    {
      text: 'Last comment',
      align: 'center',
      value: 'lastComment',
      width: 200
    },
    {
      text: 'Details',
      align: 'center',
      value: 'actions'
    }
  ]
};

export const CUSTOMER_TABS = [
  {
    id: 0,
    title: 'All',
    headers: HEADERS.ALL
  },
  {
    id: 1,
    title: 'Procedures',
    headers: HEADERS.PROCEDURES,
    params: {
      categories: ['procedure']
    }
  },
  {
    id: 2,
    title: 'Labs',
    headers: HEADERS.LABS,
    params: {
      categories: ['lab']
    }
  },
  {
    id: 3,
    title: 'Drugs',
    headers: HEADERS.DRUGS,
    params: {
      categories: ['drug']
    }
  },
  {
    id: 15,
    title: 'Vaccines',
    headers: HEADERS.VACCINES,
    params: {
      categories: ['vaccine']
    }
  },
  {
    id: 4,
    title: 'Food',
    headers: HEADERS.FOOD,
    params: {
      categories: ['food']
    }
  },
  {
    id: 5,
    title: 'Supplies',
    headers: HEADERS.SUPPLIES,
    params: {
      categories: ['supply']
    }
  },
  {
    id: 6,
    title: 'Ignored',
    headers: HEADERS.IGNORED,
    params: {
      categories: ['ignore']
    }
  },
  {
    id: 7,
    title: 'Unmatched',
    headers: HEADERS.UNMATCHED,
    params: {
      categories: ['unmatched']
    }
  },
  {
    id: 9,
    title: 'Ask customer',
    headers: HEADERS.ASK_CUSTOMER,
    params: {
      statusesNames: ['ask_customer'],
      groupBy: ['category'],
      exclude: {
        multimatch: DEFAULTS.MULTIMATCH_FIELDS
      }
    }
  },
  {
    id: 11,
    title: 'Additional analysis',
    headers: HEADERS.ADDITIONAL_ANALYSIS,
    params: {
      lastSold: true
      // groupBy: [
      //     "priceInfo.total_sold",
      //     "priceInfo.total_sold_12",
      //     "priceInfo.total_sold_24",
      //     "priceInfo.total_sold_36"
      // ]
    }
  },
  {
    id: 12,
    title: 'Conflicts',
    headers: HEADERS.CONFLICTS,
    params: {
      conflicts: ['rhapsody_code']
    }
  },
  {
    id: 13,
    title: 'Needs change',
    headers: HEADERS.NEEDS_CHANGE,
    params: {
      statusesNames: ['needs_change', 'needs_code_change', 'supply']
    }
  },
  {
    id: 14,
    title: 'Needs re-review',
    headers: HEADERS.NEEDS_RE_REVIEW,
    params: {
      statusesNames: ['needs_re_review']
    }
  }
];
